/* eslint @typescript-eslint/camelcase: 0 */
import { request } from "api";

export type IndexResponse = {
  agency: number;
  app: number;
  destination: number;
  date: string;
  days: number;
  launchedCount: number;
  uniqueLaunchedCount: number;
  purchasedCount: number;
  uniquePurchasedCount: number;
  price: number;
};

export type IndexParams = {
  appId: number;
  startAt: string;
  endAt: string;
};

export class Api {
  public static index(agencyId: number, params: IndexParams) {
    return request.get<IndexResponse[]>(
      `/agencies/${agencyId}/revenue_reports`,
      params
    );
  }
}
